export const makeOptionalLabel = (i18n, formatMessage) => {
  const label = formatMessage({ id: i18n });
  const optional = formatMessage({ id: 'common.optional' });

  return `${label} ${optional}`;
};



// WEBPACK FOOTER //
// ./src/utils/makeOptionalLabel.js